import template from './filterComplaintModal.html';
import controller from './filterComplaintModalCtrl';
import './style.scss';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    modalInstance: '<',
    filterList: '<',
  },
};
